import Vue from "vue";
import Component from "vue-class-component";

@Component({})
export default class QuizPage extends Vue {
  private selectionName = "";
  private frameworkName = "";
  protected nextPage = "";

  init(pageName: string, nextPage: string): void {
    this.selectionName = pageName + "Selection";
    this.frameworkName = pageName + "Frameworks";
    this.nextPage = nextPage;
  }

  protected selectNone(event: Event): void {
    // Deselect all other checkboxes if the user selects the None checkbox
    if ((event.currentTarget as HTMLInputElement).checked) {
      this.selected = ["none"];
      // clear the frameworks that were previously selected
      this.$store.commit(this.frameworkName, new Set());
    }
  }

  protected selectCheckbox(): void {
    // Deselect the None checkbox if it was already selected
    const selected = this.selected as string[];
    const index = selected.indexOf("none", 0);
    if (index > -1) {
      selected.splice(index, 1);
      this.selected = selected;
    }
    // Update the active frameworks based on the new selection
    const frameworks = new Set<string>();
    const checkboxes: Element[] = [...(this.$refs.form as Element).querySelectorAll("input:not(#none):checked")];
    for (const cb of checkboxes) {
      const fwList = cb.getAttribute("data-frameworks");
      if (fwList != null) {
        fwList.split(",").forEach(fw => frameworks.add(fw));
      }
    }
    this.frameworks = frameworks;
  }

  protected selectRadio(event: Event): void {
    let frameworks: Set<string>;
    const element: HTMLInputElement = event.target as HTMLInputElement;
    const fwList = element.getAttribute("data-frameworks") as string;
    if (fwList != null && fwList.length > 0) {
      frameworks = new Set(fwList.split(","));
    } else {
      frameworks = new Set<string>();
    }
    this.frameworks = frameworks;
  }

  public get selected(): string | string[] {
    return this.$store.state[this.selectionName];
  }

  public set selected(value: string | string[]) {
    this.$store.commit(this.selectionName, value);
  }

  public get frameworks(): Set<string> {
    return this.$store.state[this.frameworkName];
  }

  public set frameworks(value: Set<string>) {
    this.$store.commit(this.frameworkName, value);
  }

  protected goBack() {
    this.$store.commit("prevQuestion");
    this.$router.go(-1);
  }

  protected goNext() {
    this.$store.commit("nextQuestion");
    this.$router.push(this.nextPage);
  }
}
